import Container from "react-bootstrap/Container";
import {json, redirect, useFetcher, useLoaderData, useOutletContext} from "react-router-dom";
import Button from "react-bootstrap/Button";

export const booksOpenAdminLoader = (getAuth) => async () => {
    console.log("books open admin loader")
    try {
        let auth = await getAuth();
        let artist = auth.username === "jockerse" ? "erika" : auth.username;
        let response = await fetch(`https://botanical.ink/api/admin/${artist}/settings/books-open-until`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth.idToken.getJwtToken()}`,
            },
        });
        if (response.ok) {
            console.log("ok")
            return await response.json();
        } else {
            return json({
                error: response.status
            })
        }
    } catch (error) {
        console.log(error)
        if (error === "NOT VALID") {
            return redirect("/login")
        } else {
            throw error
        }
    }
}

export const booksOpenAdminAction = (getAuth) => async ({params, request}) => {
    console.log("create flash set action")
    try {
        let auth = await getAuth();
        let artist = auth.username;

        if (auth.username === "jockerse") {
            artist = "erika";
        } else if (auth.username === "aidan") {
            artist = "calista";
        }

        let formData = await request.formData();
        let data = {
            value: formData.get("date")
        }
        let response = await fetch(`https://botanical.ink/api/admin/${artist}/settings/books-open-until`, {
            method: "post",
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth.idToken.getJwtToken()}`,
            }
        });
        if (response.ok) {
            return await response.json();
        } else {
            return response;
        }
    } catch (error) {
        console.log(error)
        if (error === "NOT VALID") {
            return redirect("/login")
        } else {
            throw error
        }
    }
}

export const ScheduleAdmin = () => {
    const outletContext = useOutletContext();
    const loaderData = useLoaderData();
    const booksFetcher = useFetcher({key: "books-open-fetcher"});

    return (
        <Container className={"d-flex justify-content-center bg-light rounded mb-3"}>
            <h3>Schedule and Time Off</h3>
            <booksFetcher.Form method={"post"}>
                <input type={"date"}
                name={"date"}
                defaultValue={loaderData.date}
                />
                <Button type={"submit"}>
                    {booksFetcher.state === "idle" && "Submit"}
                    {booksFetcher.state === "loading" && "Loading..."}
                    {booksFetcher.state === "submitting" && "Submitting..."}
                </Button>
            </booksFetcher.Form>
        </Container>
    );
}